/* ==========================================================================
   Landing B2B "Empresas" — Copargo
   Reveal en scroll, filtros interdependientes de productos, FAB, FAQ y opiniones.
   Sin dependencias externas.
   ========================================================================== */
(function () {
  'use strict';

  var ALL = '__all__';

  /* ---------------------------------------------------------------- reveal */
  function initReveal(root) {
    var nodes = root.querySelectorAll('[data-reveal]:not([data-rv])');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (el) { el.classList.add('rv-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rv-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    Array.prototype.forEach.call(nodes, function (el) {
      el.setAttribute('data-rv', '1');
      var sibs = Array.prototype.filter.call(el.parentNode.children, function (n) {
        return n.hasAttribute && n.hasAttribute('data-reveal');
      });
      el.style.transitionDelay = Math.min(sibs.indexOf(el), 6) * 70 + 'ms';
      io.observe(el);
    });
  }

  /* ------------------------------------------------------------------- FAQ */
  /* --------------------------------------------------------- anclas suaves */
  /* Scroll suave para los CTA internos (#b2b-formulario). El destino lleva
     scroll-margin-top en el CSS, así que no queda bajo el header sticky. */
  function initAnclas(root) {
    var links = root.querySelectorAll('.b2b a[href^="#"]:not([data-ancla])');
    Array.prototype.forEach.call(links, function (a) {
      var hash = a.getAttribute('href') || '';
      if (hash.length < 2) return;
      a.setAttribute('data-ancla', '1');
      a.addEventListener('click', function (ev) {
        var target = document.getElementById(hash.slice(1));
        if (!target) return; // sin destino: comportamiento nativo
        ev.preventDefault();
        var reduce = window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (window.history && history.replaceState) history.replaceState(null, '', hash);
      });
    });
  }

  function initFaq(root) {
    root.querySelectorAll('[data-b2b-faq]').forEach(function (faq) {
      faq.querySelectorAll('.b2b-faq__q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.b2b-faq__item');
          var open = item.classList.contains('is-open');
          faq.querySelectorAll('.b2b-faq__item').forEach(function (i) {
            i.classList.remove('is-open');
            i.querySelector('.b2b-faq__q').setAttribute('aria-expanded', 'false');
          });
          if (!open) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  /* ------------------------------------------------------------- opiniones */
  function initTestimonios(root) {
    root.querySelectorAll('[data-b2b-testi]').forEach(function (wrap) {
      var cards = Array.prototype.slice.call(wrap.querySelectorAll('.b2b-testi'));
      if (!cards.length) return;
      var perView = parseInt(wrap.getAttribute('data-per-view'), 10) || 3;
      var pages = Math.max(1, Math.ceil(cards.length / perView));
      var page = 0;

      var prev = wrap.querySelector('[data-testi-prev]');
      var next = wrap.querySelector('[data-testi-next]');
      var dotsBox = wrap.querySelector('[data-testi-dots]');
      var counter = wrap.querySelector('[data-testi-count]');

      // dots
      var dots = [];
      if (dotsBox) {
        dotsBox.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          (function (idx) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Ver opiniones ' + (idx * perView + 1) + ' a ' + Math.min((idx + 1) * perView, cards.length));
            b.addEventListener('click', function () { go(idx); });
            dotsBox.appendChild(b);
            dots.push(b);
          })(i);
        }
      }

      function go(p) {
        page = (p + pages) % pages;
        cards.forEach(function (c, i) {
          var visible = Math.floor(i / perView) === page;
          c.hidden = !visible;
          // al cambiar de página, replegar los textos expandidos
          var q = c.querySelector('.b2b-testi__quote');
          var more = c.querySelector('.b2b-testi__more');
          if (q && more && q.dataset.clampable === '1') {
            q.classList.add('is-clamped');
            more.textContent = more.getAttribute('data-label-more');
          }
        });
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === page ? 'true' : 'false'); });
        if (counter) {
          var from = page * perView + 1;
          var to = Math.min((page + 1) * perView, cards.length);
          counter.textContent = 'Opiniones ' + from + '–' + to + ' de ' + cards.length;
        }
      }

      // prev y next van en direcciones OPUESTAS (en la landing original hacían lo mismo)
      if (prev) prev.addEventListener('click', function () { go(page - 1); });
      if (next) next.addEventListener('click', function () { go(page + 1); });

      // "leer opinión completa"
      cards.forEach(function (c) {
        var q = c.querySelector('.b2b-testi__quote');
        var more = c.querySelector('.b2b-testi__more');
        if (!q || !more) return;
        q.dataset.clampable = '1';
        more.addEventListener('click', function () {
          var clamped = q.classList.toggle('is-clamped');
          more.textContent = clamped ? more.getAttribute('data-label-more') : more.getAttribute('data-label-less');
        });
      });

      go(0);
    });
  }

  /* -------------------------------------------------- productos + filtros */
  function initProductos(root) {
    root.querySelectorAll('[data-b2b-productos]').forEach(function (sec) {
      var cards = Array.prototype.slice.call(sec.querySelectorAll('.b2b-card'));
      var plagaBtns = Array.prototype.slice.call(sec.querySelectorAll('[data-plaga]'));
      var catBtns = Array.prototype.slice.call(sec.querySelectorAll('[data-cat]'));
      var grid = sec.querySelector('[data-grid]');
      var pager = sec.querySelector('[data-pager]');
      var countEl = sec.querySelector('[data-count]');
      var emptyEl = sec.querySelector('[data-empty]');

      var porPagina = parseInt(grid && grid.getAttribute('data-por-pagina'), 10) || 16;
      var state = { plaga: ALL, cat: ALL, page: 1 };

      function listOf(el, attr) {
        var v = el.getAttribute(attr) || '';
        return v.split(' ').filter(Boolean);
      }

      function matchesPlaga(card, plaga) {
        return plaga === ALL || listOf(card, 'data-plagas').indexOf(plaga) !== -1;
      }
      function matchesCat(card, cat) {
        return cat === ALL || listOf(card, 'data-cats').indexOf(cat) !== -1;
      }

      /* Interdependencia: las categorías disponibles se derivan de los productos
         que realmente pertenecen a la plaga elegida. */
      function categoriasDisponibles(plaga) {
        var set = {};
        cards.forEach(function (c) {
          if (!matchesPlaga(c, plaga)) return;
          listOf(c, 'data-cats').forEach(function (h) { set[h] = true; });
        });
        return set;
      }

      /* Ventana de páginas: primera, última, la actual y sus vecinas. Con 13
         páginas no caben 13 botones en un móvil. */
      function ventana(total, actual) {
        var out = [], i;
        for (i = 1; i <= total; i++) {
          if (i === 1 || i === total || Math.abs(i - actual) <= 1) out.push(i);
          else if (out[out.length - 1] !== '...') out.push('...');
        }
        return out;
      }

      function pintarPager(total) {
        if (!pager) return;
        pager.innerHTML = '';
        pager.hidden = total <= 1;
        if (total <= 1) return;

        function boton(txt, pagina, opts) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'b2b-pager__btn' + (opts && opts.cls ? ' ' + opts.cls : '');
          b.textContent = txt;
          if (opts && opts.label) b.setAttribute('aria-label', opts.label);
          if (opts && opts.actual) b.setAttribute('aria-current', 'page');
          if (opts && opts.off) b.disabled = true;
          else b.addEventListener('click', function () { irA(pagina); });
          pager.appendChild(b);
        }

        boton('‹', state.page - 1, { cls: 'b2b-pager__btn--nav', label: 'Página anterior', off: state.page === 1 });
        ventana(total, state.page).forEach(function (n) {
          if (n === '...') {
            var g = document.createElement('span');
            g.className = 'b2b-pager__gap';
            g.textContent = '…';
            g.setAttribute('aria-hidden', 'true');
            pager.appendChild(g);
            return;
          }
          boton(String(n), n, { cls: n === state.page ? 'is-active' : '', actual: n === state.page, label: 'Página ' + n });
        });
        boton('›', state.page + 1, { cls: 'b2b-pager__btn--nav', label: 'Página siguiente', off: state.page === total });
      }

      function irA(pagina) {
        state.page = pagina;
        render();
        /* al cambiar de página el usuario espera ver el principio de la grilla */
        var y = window.scrollY + sec.getBoundingClientRect().top - 90;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }

      function render() {
        var disponibles = categoriasDisponibles(state.plaga);

        // si la categoría activa ya no aplica a la plaga elegida, se vuelve a "Todas"
        if (state.cat !== ALL && !disponibles[state.cat]) state.cat = ALL;

        catBtns.forEach(function (b) {
          var h = b.getAttribute('data-cat');
          var on = h === ALL || !!disponibles[h];
          b.disabled = !on;
          b.setAttribute('aria-disabled', on ? 'false' : 'true');
          b.setAttribute('aria-pressed', state.cat === h ? 'true' : 'false');
        });
        plagaBtns.forEach(function (b) {
          b.setAttribute('aria-pressed', state.plaga === b.getAttribute('data-plaga') ? 'true' : 'false');
        });

        var visibles = cards.filter(function (c) {
          return matchesPlaga(c, state.plaga) && matchesCat(c, state.cat);
        });

        var total = Math.max(1, Math.ceil(visibles.length / porPagina));
        if (state.page > total) state.page = total;
        if (state.page < 1) state.page = 1;
        var desde = (state.page - 1) * porPagina;

        cards.forEach(function (c) { c.hidden = true; });
        visibles.slice(desde, desde + porPagina).forEach(function (c) { c.hidden = false; });

        var n = visibles.length;
        if (countEl) countEl.textContent = n + (n === 1 ? ' producto' : ' productos');
        if (emptyEl) emptyEl.hidden = n !== 0;
        pintarPager(total);
        syncFab();
      }

      /* Cambiar un filtro siempre vuelve a la primera página: quedarse en la 7
         de un resultado que ahora tiene 2 páginas deja la grilla vacía. */
      function aplicarFiltro(cambio) {
        cambio();
        state.page = 1;
        render();
      }

      plagaBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          aplicarFiltro(function () { state.plaga = b.getAttribute('data-plaga'); });
        });
      });
      catBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          aplicarFiltro(function () { state.cat = b.getAttribute('data-cat'); });
        });
      });

      /* ---- FAB: espejo de los filtros mientras la sección está en pantalla ---- */
      var fab = sec.querySelector('[data-fab]');
      var panel = sec.querySelector('[data-fab-panel]');

      function syncFab() {
        if (!panel) return;
        panel.querySelectorAll('[data-plaga]').forEach(function (b) {
          b.setAttribute('aria-pressed', state.plaga === b.getAttribute('data-plaga') ? 'true' : 'false');
        });
        var disponibles = categoriasDisponibles(state.plaga);
        panel.querySelectorAll('[data-cat]').forEach(function (b) {
          var h = b.getAttribute('data-cat');
          var on = h === ALL || !!disponibles[h];
          b.disabled = !on;
          b.setAttribute('aria-pressed', state.cat === h ? 'true' : 'false');
        });
      }

      if (fab && panel) {
        fab.addEventListener('click', function () { panel.classList.toggle('is-open'); });
        var onScroll = function () {
          var r = sec.getBoundingClientRect();
          var on = r.top < window.innerHeight * 0.35 && r.bottom > window.innerHeight * 0.4;
          fab.classList.toggle('is-on', on);
          if (!on) panel.classList.remove('is-open');
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
      }

      render();
    });
  }

  /* ------------------------------------------------------------ formulario */
  function initFormulario(root) {
    root.querySelectorAll('[data-b2b-form]').forEach(function (form) {
      var result = form.querySelector('[data-form-result]');
      var okBox = form.parentNode.querySelector('[data-form-ok]');

      function msg(html) { if (result) result.innerHTML = html; }
      function clearLater() { setTimeout(function () { msg(''); }, 4000); }

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var campos = Array.prototype.slice.call(form.querySelectorAll('[data-field]'));
        var data = {};
        var falla = false;

        campos.forEach(function (wrap) {
          var input = wrap.querySelector('input, select, textarea');
          var errBox = wrap.querySelector('.b2b-field__error');
          var val = (input.value || '').trim();
          var req = input.hasAttribute('required');
          var err = '';

          if (req && !val) err = input.getAttribute('data-msg-required') || 'Este campo es obligatorio';
          else if (val && input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) err = 'Revisa el formato del email';
          else if (val && input.type === 'tel' && val.replace(/\D/g, '').length < 8) err = 'Ingresa un teléfono válido';

          wrap.classList.toggle('has-error', !!err);
          if (errBox) errBox.textContent = err;
          if (err) falla = true;
          data[input.name] = val;
        });

        if (falla) {
          msg('<div style="color:#c0392b; font-size:14px;">Revisa los campos marcados.</div>');
          return;
        }

        if (typeof window.sendExtendedContactEmail !== 'function') {
          console.warn('[b2b] EmailJS no disponible');
          msg('<div style="color:#c0392b; font-size:14px;">No se pudo enviar. Inténtalo más tarde.</div>');
          return;
        }

        msg('<div style="color:#7692dd; padding:12px; background:#f0f4ff; border-radius:8px; text-align:center; font-size:14px;">Enviando solicitud…</div>');

        var payload = {
          user_name: data.user_name,
          user_email: data.user_email,
          user_phone: data.user_phone,
          user_region: data.user_region,
          user_requirement: data.user_requirement,
          message: data.message,
          // campos propios de la landing B2B
          user_company: data.user_company,
          user_role: data.user_role,
          to_email: (window.EMAILJS_CONFIG && window.EMAILJS_CONFIG.companyEmail) || 'contacto@copargo.cl',
          from_name: 'Formulario Empresas (B2B) Copargo'
        };

        window.sendExtendedContactEmail(payload)
          .then(function () {
            form.reset();
            msg('');
            if (okBox) { okBox.hidden = false; form.hidden = true; }
          })
          .catch(function (err) {
            console.error('[b2b] error al enviar', err);
            msg('<div style="color:#c0392b; font-size:14px;">No se pudo enviar. Inténtalo más tarde.</div>');
            clearLater();
          });
      });
    });
  }

  /* ------------------------------------------------------------------ boot */
  /* ------------------------------------------------------------- variantes */
  /* Chips de presentacion en la tarjeta. Es la misma logica que tenia el <select>:
     se lee el data-variant del chip, se reescribe el data-product del boton Cotizar
     y se cambia la imagen. Lo unico nuevo es el estado visual del chip y la linea
     de disponibilidad. El carrito ya indexa por id de variante, asi que aguas abajo
     no cambia nada: dos formatos del mismo producto siguen entrando como lineas
     distintas. */
  function initVariantes(root) {
    root.querySelectorAll('[data-b2b-productos] [data-variantes]').forEach(function (wrap) {
      if (wrap.getAttribute('data-var-ready')) return;
      wrap.setAttribute('data-var-ready', '1');

      var chips = Array.prototype.slice.call(wrap.querySelectorAll('[data-variant-chip]'));
      if (!chips.length) return;                    // producto de un solo formato

      var card = wrap.closest('.b2b-card');
      if (!card) return;
      var btn = card.querySelector('.cotizacion-btn-main');
      var img = card.querySelector('.b2b-card__media img');
      var stock = wrap.querySelector('[data-stock]');
      var stockTxt = wrap.querySelector('[data-stock-text]');
      var stockSku = wrap.querySelector('[data-stock-sku]');

      function aplicar(chip) {
        var raw = chip.getAttribute('data-variant');
        if (raw && btn) {
          try {
            btn.setAttribute('data-product', JSON.stringify(JSON.parse(raw)));
          } catch (err) {
            return;
          }
        }

        var src = chip.getAttribute('data-img');
        if (img && src) {
          img.removeAttribute('srcset');
          img.src = src;
        }

        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        var disponible = chip.getAttribute('data-available') === '1';
        if (stock) stock.classList.toggle('b2b-stock--agotado', !disponible);
        if (stockTxt) stockTxt.textContent = disponible ? 'Disponible' : 'Agotado';
        if (stockSku) stockSku.textContent = chip.getAttribute('data-sku') || '';

        /* El boton alterna a "Ver cotizacion" segun la variante que lleva encima;
           al cambiarla hay que recalcular ese estado. updateUI relee el data-product
           de cada boton, asi que basta con llamarlo. */
        if (window.quotationCart && typeof window.quotationCart.updateUI === 'function') {
          window.quotationCart.updateUI();
        }
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () { aplicar(chip); });

      });
    });
  }

  function boot(root) {
    root = root || document;
    initReveal(root);
    initAnclas(root);
    initFaq(root);
    initTestimonios(root);
    initProductos(root);
    initVariantes(root);
    initFormulario(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // el editor de temas recarga secciones sueltas
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
